import classNames from 'classnames';
import { FC } from 'react';

import { Button, Flex, Text } from '@servicetitan/anvil2';
import { useDependencies } from '@servicetitan/react-ioc';

import { EquipmentItemModel, EquipmentListModel } from '../../../models/equipment.model';
import { MessageType } from '../../../models/message-type.model';
import { ChatStore } from '../../../stores/chat.store';
import { formatDate } from '../../../utils/format-date';
import { MessageCard } from '../../message-card/message-card';

interface EquipmentListProps {
    data: EquipmentListModel;
}

export const EquipmentList: FC<EquipmentListProps> = ({ data }) => {
    const [chatStore] = useDependencies(ChatStore);

    const handleShowMore = (equipmentItem: EquipmentItemModel) => {
        chatStore.enqueueMessages([
            {
                isMine: false,
                type: MessageType.RichText,
                showAvatar: true,
                text: `Here are more details about <strong>${equipmentItem.name}</strong>:`,
            },
            {
                isMine: false,
                type: MessageType.EquipmentDetails,
                data: equipmentItem,
            },
        ]);
    };

    return data.equipment.map((equipmentItem, index) => {
        return (
            <MessageCard
                className={classNames(index > 0 && 'm-t-2')}
                key={equipmentItem.id}
                flexDirection="column"
            >
                <div className="m-b-1">
                    <Text variant="eyebrow" className="m-b-half" size="small">
                        Name
                    </Text>
                    <Text size="small">{equipmentItem.name}</Text>
                </div>

                <div className="m-b-1">
                    <Text variant="eyebrow" className="m-b-half" size="small">
                        Manufacturer
                    </Text>
                    <Text size="small">{equipmentItem.manufacturer}</Text>
                </div>

                <div className="m-b-1">
                    <Text variant="eyebrow" className="m-b-half" size="small">
                        Model Number
                    </Text>
                    <Text size="small">{equipmentItem.model_number}</Text>
                </div>

                <div className="m-b-1">
                    <Text variant="eyebrow" className="m-b-half" size="small">
                        Serial Number
                    </Text>
                    <Text size="small">{equipmentItem.serial_number}</Text>
                </div>

                <div>
                    <Text variant="eyebrow" className="m-b-half" size="small">
                        Installation Date
                    </Text>
                    <Text size="small">
                        {formatDate(new Date(equipmentItem.installation_date))}
                    </Text>
                </div>

                <Flex justifyContent="center">
                    <Button
                        appearance="ghost"
                        className="m-t-1"
                        size="small"
                        onClick={() => handleShowMore(equipmentItem)}
                    >
                        View more info
                    </Button>
                </Flex>
            </MessageCard>
        );
    });
};
